import React from "react";
import customCorrencyConverter from "../../Currency/customCorrencyConverter";
import { useTranslation } from "react-i18next";

const QuickBalance = ({ tiles, currency, conversionFactor }) => {
  const { t } = useTranslation();
  const isLoading = !tiles;

  const currencySymbol = currency?.symbolLeft ?? "$";

  const skeletonBoxStyle = {
    height: "16px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    width: "100%",
    animation: "pulse 1.5s infinite ease-in-out",
  };

  const renderSkeleton = () => (
    <div className="quick_balance_Box">
      <div className="quick_balance_Box_ico">
        <div style={{ ...skeletonBoxStyle, width: "100%", height: "100%" }} />
      </div>
      <div className="quick_balance_Box_cnt">
        <div style={{ ...skeletonBoxStyle, width: "60%" }} />
        <div style={{ ...skeletonBoxStyle, width: "40%" }} />
        <div style={{ ...skeletonBoxStyle, width: "50%" }} />
      </div>
    </div>
  );

  return (
    <div data-tut="dashboardTiles" className="quick_balance_section">
      <div className="quick_balance_section_row">
        {isLoading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <React.Fragment key={index}>{renderSkeleton()}</React.Fragment>
          ))
        ) : (
          <>
            <div className="quick_balance_Box">
              <div className="quick_balance_Box_ico">
                <img src="/images/balance_ewallet_ico.svg" alt="" />
              </div>
              <div className="quick_balance_Box_cnt">
                <span>{t("Global Pool")}</span>
                <strong>
                  {currencySymbol}{" "}
                  {customCorrencyConverter(tiles?.globalTotalBalance ?? 0, conversionFactor)}
                </strong>
                <span style={{ fontSize: ".8rem" }}>
                  Participants : {tiles?.globalPoolCount}
                </span>
              </div>
            </div>

            <div className="quick_balance_Box">
              <div className="quick_balance_Box_ico">
                <img src="/images/balance_commision_ico.svg" alt="" />
              </div>
              <div className="quick_balance_Box_cnt">
                <span>{t("Vision Pool")}</span>
                <strong>
                  {currencySymbol}{" "}
                  {customCorrencyConverter(tiles?.visionTotalBalance ?? 0, conversionFactor)}
                </strong>
                <span style={{ fontSize: ".8rem" }}>
                  Participants : {tiles?.visionPoolCount}
                </span>
              </div>
            </div>

            <div className="quick_balance_Box">
              <div className="quick_balance_Box_ico">
                <img src="/images/balance_commision_ico.svg" alt="" />
              </div>
              <div className="quick_balance_Box_cnt">
                <span>{t("Mission X")}</span>
                <strong>
                  {currencySymbol}{" "}
                  {customCorrencyConverter(tiles?.misionxBalance ?? 0, conversionFactor)}
                </strong>
              </div>
            </div>

            <div className="quick_balance_Box">
              <div className="quick_balance_Box_ico">
                <img src="/images/balance_pending_ico.svg" alt="" />
              </div>
              <div className="quick_balance_Box_cnt">
                <span>{t("XION")}</span>
                <strong>
                  {currencySymbol}{" "}
                  {customCorrencyConverter(tiles?.xionBalance ?? 0, conversionFactor)}
                </strong>
              </div>
            </div>


            <div className="quick_balance_Box">
              <div className="quick_balance_Box_ico">
                <img src="/images/balance_commision_ico.svg" alt="" />
              </div>
              <div className="quick_balance_Box_cnt">
                <span>{t("Turquoise pool")}</span>
                <strong>
                  {currencySymbol}{" "}
                  {customCorrencyConverter(tiles?.turquoiseTotalBalance ?? 0, conversionFactor)}
                </strong>
                <span style={{ fontSize: ".8rem" }}>
                  Participants : {tiles?.turquoiseCount}
                </span>
              </div>
            </div>

          </>
        )}
      </div>
    </div>
  );
};

export default QuickBalance;
